<div class="alert alert-{{type}}" role="alert" *ngIf="message?.length">
	{{message}}
</div>
